export class SocketHangUpError extends Error {
}
